import { useMutation, useQueryClient } from 'react-query';
import { useAxiosInstance } from '../common';

interface Params {
  sapFlowId: string;
  sapFlowParams: any;
}

const useSapConfigParamsUpdate = () => {
  const axios = useAxiosInstance();
  const queryClient = useQueryClient();
  return useMutation(
    async (params: Params) => {
      const response = await axios.put<any>('file_sapflow/' + params.sapFlowId + '/params', params.sapFlowParams);
      return response.data;
    },
    {
      onSuccess: (_data, variables) => {
        queryClient.invalidateQueries(['sapFlowParams', variables.sapFlowId], { refetchInactive: true });
      },
    }
  );
};

export default useSapConfigParamsUpdate;
